import { mixinContextMembers } from './context';
import { mixinLessonAssignMembers } from './lesson-assign';
import { mixinSocketMembers } from './socket';
import { mixinToastMembers } from './toast';

import { TBaseConstructor } from './_wrapper';

export function mixinAssignLessonButtonMembers<TBase extends TBaseConstructor>(Base: TBase) {
    return class extends mixinLessonAssignMembers(mixinToastMembers(mixinSocketMembers(mixinContextMembers(Base)))) {};
}

export { type Props, AssignLessonButtonWrapper } from './_wrapper';
